import React from 'react';
import { motion } from 'framer-motion';
export function SystemOverview() {
  const tomos = [{
    emoji: '🥞',
    title: 'Desayunos saludables para reducir peso',
    desc: '20 Recetas para comenzar tu día con energía.'
  }, {
    emoji: '🥘',
    title: 'Almuerzos para reducir peso',
    desc: 'Platos completos y livianos que te mantiene satisfecho.'
  }, {
    emoji: '🥗',
    title: 'Cenas livianas para reducir peso',
    desc: 'Recetas fáciles y digestivas para cerrar el día cuidando tu alimentación.'
  }, {
    emoji: '🍌',
    title: 'Snacks para reducir peso',
    desc: 'Ideas practicas para calmar el hambre entre comidas.'
  }, {
    emoji: '🍮',
    title: 'Postres saludables',
    desc: 'Alternativas para los antojos nocturnos.'
  }, {
    emoji: '🌿',
    title: 'Recetas detox',
    desc: 'Preparaciones frescas que ayudan a desinflamar y acompañar tu progreso.'
  }];
  return <section className="pt-8 pb-20 px-4 bg-brand-bgAlt" data-id="element-160">
      <div className="max-w-5xl mx-auto flex flex-col items-center" data-id="element-161">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-162">
          <div className="inline-block bg-green-600 text-white font-bold px-4 py-1.5 rounded-full mb-3 uppercase tracking-widest text-sm shadow-sm" data-id="element-163">
            🏆 SISTEMA COMPLETO
          </div>
          <h2 className="text-4xl md:text-6xl font-poppins font-black text-brand-text mb-2" data-id="element-164">
            🥗 SALUD EN TU PLATO
          </h2>
          <h3 className="text-2xl md:text-3xl font-poppins font-bold text-brand-accent mb-3" data-id="element-165">
            BAJÁ DE PESO SIN SUFRIR
          </h3>
          <p className="text-lg md:text-xl text-brand-textBody font-medium max-w-2xl mx-auto" data-id="element-166">
            6 Tomos + 3 Bonus — Todo lo que necesitás para bajar de peso sin
            dieta.
          </p>
        </motion.div>

        <div className="w-full" data-id="element-167">
          <h4 className="text-2xl font-poppins font-bold text-center mb-12 text-brand-text" data-id="element-168">
            📦 ¿Qué incluye tu pack?
          </h4>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-169">
            {tomos.map((tomo, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="bg-white p-8 rounded-3xl border border-green-100 shadow-sm hover:shadow-md transition-shadow flex flex-col items-center text-center" data-id="element-170">
                <div className="text-4xl mb-6 bg-green-50 w-16 h-16 rounded-full flex items-center justify-center border border-green-200" data-id="element-171">
                  {tomo.emoji}
                </div>
                <h5 className="text-xl font-poppins font-bold text-brand-text mb-3" data-id="element-172">
                  {tomo.title}
                </h5>
                <p className="text-gray-600 font-medium leading-relaxed" data-id="element-173">
                  {tomo.desc}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}